import { createMuiTheme } from '@material-ui/core/styles';

const MuiTheme = createMuiTheme({
    typography: {
        fontFamily: 'Simplon'
    },
    colors: {
        primary: '#c2cd06',
        secondary: '#c2cd06',
        success: '#00aa0b',
        error: '#f8562c',
        warning: '#ff944d',
        danger: '#f8562c',
        info: '#009df7',
        light: '#f7f7f7',
        dark: '#222',
        link: '#fff',
        gray: '#909090',
        white: '#fff',
        lightgray: 'hsl(0,0%,95%)',
        colorButtonActive: '#c2cd06',
        colorButtonDeactive: '#dedede'
    }
});

export default MuiTheme;
export { MuiTheme };
